/* eslint-disable */
import React, { Component } from 'react';
import { SwaggerlessContext } from 'Context/SwaggerlessContext';

export const withQuestionnaireFuncs = (Wrapped) => {
  class WithIndexedQuestionnaireAnswer extends Component {
    constructor(props) {
      super(props);
    }

    render() {
      return (
        <SwaggerlessContext.Consumer>
          {({putQuestionnaireAnswer, getQuestionnaireAnswer, getIndexedQuestionnaireAnswer, getQuestionnaireIndexList, createQuestionnaireIndex, removeQuestionnaireIndex}) => {
            return <Wrapped
              {...this.props}
              uploadValue={putQuestionnaireAnswer}
              getQuestionnaireAnswer={getQuestionnaireAnswer}
              getIndexedQuestionnaireAnswer={getIndexedQuestionnaireAnswer}
              fetchIndex={getQuestionnaireIndexList}
              createIndex={createQuestionnaireIndex}
              removeIndex={removeQuestionnaireIndex}
            />
          }}
        </SwaggerlessContext.Consumer>
      );
    }
  }

  return WithIndexedQuestionnaireAnswer;
}
